import { useState } from "react";

const useSpaceSelected = () => {
    const [spaceSelected, setSpaceSelected] = useState(null);
	function update(values) {
		setSpaceSelected(prev => ({
			...prev,
			...values
		}));
	}
	function isEmpty() {
		return spaceSelected === null;
	}
	return {
		value: spaceSelected,
		update, isEmpty
	};
}	
	
export default useSpaceSelected;